'use client'
import { memo, useEffect, type FC, type ReactNode } from 'react'
import dynamic from 'next/dynamic'
import StyledComponentsRegistry from '@/utils/styled-components-registry'
import { Susy } from '@/styles'
import { PRO, STAGING } from '@/utils'
import { ModalsProvider, ToastProvider, PageTransitionProvider, PageDesignProvider } from '@/context'
import type { TypeDevice } from '@digital-you/dy-warehouse/schema'
import type { TypeCmsLayout, TypeLang } from '@/schema'
import { TransitionManager } from './TransitionManager'

type Props = {
  children: ReactNode
  lang?: TypeLang
  headerAgentDeviceType?: TypeDevice
  layoutData: TypeCmsLayout
}

const DynamicModalUserJourneyStandalone = dynamic(() => import('@/components/modals/ModalUserJourneyStandalone').then(mod => mod.ModalUserJourneyStandalone), { ssr: false })
const DynamicModalUserJourneyCasambi = dynamic(() => import('@/components/modals/ModalUserJourneyCasambi').then(mod => mod.ModalUserJourneyCasambi), { ssr: false })
const DynamicModalUserJourneyDaliDt8 = dynamic(() => import('@/components/modals/ModalUserJourneyDaliDt8').then(mod => mod.ModalUserJourneyDaliDt8), { ssr: false })
const DynamicModalVideo = dynamic(() => import('@/components/modals/ModalVideo').then(mod => mod.ModalVideo), { ssr: false })


const ClientProviders: FC<Props> = memo(({ children, headerAgentDeviceType, layoutData }) => {
  useEffect(() => {
    document.getElementById('cortina').classList.add('load')
  }, [])

  return (
    <StyledComponentsRegistry>
      <PageTransitionProvider>
				<ToastProvider>
					<ModalsProvider>
						<PageDesignProvider>
							<div id='cortina' className="cortina-klk"></div>
							<TransitionManager layoutData={layoutData} headerAgentDeviceType={headerAgentDeviceType}>
								{children}
								<DynamicModalUserJourneyStandalone />
								<DynamicModalUserJourneyCasambi />
								<DynamicModalUserJourneyDaliDt8 />
								<DynamicModalVideo />
							</TransitionManager>
						</PageDesignProvider>
					</ModalsProvider>
				</ToastProvider>
      </PageTransitionProvider>
      {(!STAGING && !PRO) && <Susy />}
    </StyledComponentsRegistry>
  )
})

export default ClientProviders
